module.exports = __webpack_public_path__ + "static/media/default_sms.dfdd34e7.png";